
import {
  BrowserRouter as Router,
  Switch,
  Route,
  
} from "react-router-dom";
import './App.css';

import Home from "./components/Home/Home";
import LeagueDetails from "./components/LeagueDetails/LeagueDetails";
import NotFound from "./components/NotFound/NotFound";

function App() {
  
  return (
    <Router>
    
 
        <Switch>
          <Route exact path="/home">
            <Home></Home>
          </Route>
          <Route path="/league/:leagueName">
          <LeagueDetails></LeagueDetails>
          </Route>
          <Route exact path="/">
            <Home></Home>
          </Route>
          <Route path="*">
            <NotFound></NotFound>
          </Route>
        </Switch>
      
  </Router>
  );
}

export default App;
